export const viCareAndroidTranslationKey = 'alerts_release_notes_payload_android_';
export const viCareIOSTranslationKey = 'alerts_release_notes_payload_ios_';

export interface ViGuideChangeLog {
  version: string;
  date: string;
  improvements?: string;
  fixes?: string;
  special?: string;
}

export interface ViCareChangeLog {
  version: string;
  improvements?: string[];
  fixes?: string[];
}

export interface UpdatesAmount {
  viGuideUpdatesAmount: number;
  viCareAndroidUpdatesAmount: number;
  viCareIOSUpdatesAmount: number;
}

export enum ChangeLogTypeEnum {
  ViGuide = 'ViGuide',
  ViCareIOS = 'ViCareIOS',
  ViCareAndroid = 'ViCareAndroid',
}
